function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.257 9.775l3.89-3.758L.39 2.126 1.594.972l4.912 5.086-5.087 4.912L.257 9.775z",
  fill: "#3864FB"
});

function SvgArrowright(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgArrowright;